export default __webpack_public_path__ + "static/media/beach2.16e40a65.webp";